export const NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
};
